import type { Message, TiaValidationMetadata } from '../types';

/** Live turns expose a top-level record; reloaded turns retain it in metrics. */
export function readMessageTiaValidation(
  message: Pick<Message, 'tiaValidation' | 'generationMetrics'>,
): TiaValidationMetadata | null {
  return message.tiaValidation ?? message.generationMetrics?.tiaValidation ?? null;
}
